import React, { useState, useEffect, useRef } from 'react';
import { ArrowDown, SearchIcon } from "../../../icons/icons";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const CustomSelect = ({ options, onchange, name, label, disable, defaultValue = undefined, enName, agent = false, hideSearch = false, searchField = [] }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [value, setValue] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [searchTerm, setSearchTerm] = useState('');
  const selectRef = useRef(null);
  const { t } = useTranslation();
  const lng = useSelector((state) => state.common.lng)
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  useEffect(() => {
    setFilteredOptions(options);
  }, [options]);

  useEffect(() => {
    if (defaultValue) {
      if (defaultValue[`${lng}_name`]) {
        setValue(defaultValue[`${lng}_name`]);
      } else if (defaultValue[`role_key`] && !agent) {
        setValue(defaultValue[`role_key`]);
      } else {
        setValue(defaultValue?.[`name`] + " " + (defaultValue?.[`last_name`] ?? ''));
      }

    } else {
      setValue('')
    }
  }, [defaultValue])

  const handleOptionClick = (option) => {
    setSelectedOption(option);
    setValue(option["code"] ? !enName ? ((option[`${lng}_name`] || (option[`name`] + " " + (option[`last_name`] ? option[`last_name`] : ""))) + " - " + option["code"]) : (option[`en_name`] + " - " + option[`fa_name`]) + " - " + option["code"] : option[`${lng}_name`] || (option[`name`] + " " + (option[`last_name`] ? option[`last_name`] : "")));
    onchange({ name: name, value: option.id });
    setIsOpen(false);
  };

  const handleSearch = (e) => {
    setFilteredOptions([]);

    const term = e.target.value.toLowerCase();
    setSearchTerm(term);

    const filtered = options.filter(option =>
      option?.['name']?.toLowerCase().includes(term.toLowerCase())
      || t(option?.name)?.toLowerCase().includes(term.toLowerCase())
      || (Array.isArray(searchField)  && searchField?.length> 0 ? searchField.findIndex(s => option?.[s]?.toLowerCase().includes(term.toLowerCase())) != -1 : false)
    );


    setTimeout(() => {
      setFilteredOptions(filtered);
    }, 10)

  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [selectRef]);




  return (
    <div className={`relative w-full ${disable ? "opacity-50 pointer-events-none" : ""}`} ref={selectRef}>
      <div
        className={`flex justify-between px-2.5 pb-2.5 pt-4 w-full text-sm outline outline-1 outline-gray-300 text-gray-900 bg-transparent rounded-lg appearance-none dark:text-white focus:outline-none focus:ring-0 focus:border-main peer cursor-pointer`}
        onClick={toggleDropdown}
      >
        {value || t(label)}
        <ArrowDown />
      </div>
      {isOpen && (
        <div
          className="absolute z-20 w-full bg-white dark:bg-gray-900 rounded-lg shadow-lg mt-1 max-h-[200px] overflow-auto"
        >
          {!hideSearch && <div className="flex items-center bg-gray-100 dark:bg-gray-800 sticky top-0 ">
            <input
              type="search"
              placeholder={t("search")}
              className="w-full bg-transparent border-none outline-none text-gray-900 dark:text-white"
              value={searchTerm}
              onChange={handleSearch}
              id={`id-${name}`}
            />
            <div className={"mx-2"}>
              <SearchIcon />
            </div>
          </div>}
          {filteredOptions?.map((option, index) => (
            <div
              key={option[`${lng}_name`] + name + index}
              className={`px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-800 cursor-pointer ${selectedOption?.id === option.id ? ' ' : ''}`}
              onClick={() => handleOptionClick(option)}
            >
              {option["code"] ? !enName ? ((option[`${lng}_name`] || (option[`name`] + " " + (option[`last_name`] ? option[`last_name`] : ""))) + " - " + option["code"]) : (option[`en_name`] + " - " + option[`fa_name`]) + " - " + option["code"] : option[`${lng}_name`] || (option[`name`] + " " + (option[`last_name`] ? option[`last_name`] : ""))}
            </div>
          ))}
        </div>
      )}
      <label
        htmlFor={`id-${name}`}
        className={`absolute ${value ? " text-main !text-[10px] -translate-y-4 top-2" : "top-1/2 -translate-y-1/2"} peer-focus:text-main text-sm text-gray-500 dark:text-gray-400 duration-300 transform  z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2  peer-focus:dark:text-blue-500  peer-placeholder-shown:scale-100 peer-focus:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-4 start-1 cursor-pointer`}
        onClick={toggleDropdown}
      >
        {t(label)}
      </label>
    </div>
  );
};

export default CustomSelect;
